<template>
  <layouts-header v-if="!authStore.user"></layouts-header>
  <user-header v-if="authStore.user"></user-header>

  <breadcrumb :text="text" :text1="text1" :title="title"/>

  <!-- Page Content -->
  <div class="content">
    <div class="container">
      <!-- Sort By -->
      <div class="row">
        <div class="col-lg-12">
          <div class="sortby-section">
            <div class="sorting-info">
              <div class="row d-flex align-items-center">
                <div class="col-xl-4 col-lg-3 col-sm-12 col-12">
                  <div class="count-search"></div>
                </div>
                <div class="col-xl-8 col-lg-9 col-sm-12 col-12">
                  <div class="sortby-filter-group">
                    <div class="grid-listview">
                      <ul class="nav">
                        <li><span>Chế độ xem</span></li>
                        <li>
                          <router-link class="active" to="/giai-dau">
                            <img alt="Icon" src="@/assets/img/icons/sort-01.svg"/>
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/list-giai-dau">
                            <img alt="Icon" src="@/assets/img/icons/sort-02.svg"/>
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Sort By -->

      <div class="row justify-content-center">
        <!-- Featured Item -->
        <div v-for="item in data" :key="item.id" class="col-lg-4 col-md-6">
          <div class="featured-venues-item">
            <div class="listing-item listing-item-grid d-flex flex-column">
              <div class="listing-img">
                <router-link
                    :to="`/giai-dau/chi-tiet-giai-dau/${encodeURIComponent(item?.name)}`"
                >
                  <img :alt="item?.photo?.documentId" :src="`${url + item?.photo?.url}`"/>
                </router-link>
              </div>
              <div class="listing-content flex-grow-1 d-flex flex-column">
                <h3 class="listing-title">
                  <router-link :to="`/giai-dau/chi-tiet-giai-dau/${encodeURIComponent(item?.name)}`">
                    {{ item.name }}
                  </router-link>
                </h3>
                <ul class="mb-2">
                  <li class="arena-name">
                    <span><i class="feather-map-pin me-2"></i>{{ item?.arenas[0]?.name }}</span>
                  </li>
                </ul>
                <div class="listing-details-group flex-grow-1">
                  <p>{{ item.description || "Không có mô tả" }}</p>
                </div>
                <div class="coach-btn">
                  <ul>
                    <li>
                      <router-link
                          :to="`/giai-dau/chi-tiet-giai-dau/${encodeURIComponent(item?.name)}`"
                          class="btn btn-primary w-100"
                      ><i class="feather-eye me-2"></i>Xem
                      </router-link
                      >
                    </li>
                    <li>
                      <router-link
                          :to="`/giai-dau/chi-tiet-giai-dau/${encodeURIComponent(item?.name)}`"
                          class="btn btn-secondary w-100"
                      ><i class="feather-calendar me-2"></i>Tham gia
                      </router-link
                      >
                    </li>
                  </ul>
                </div>
                <div class="avalbity-review">
                  <ul>
                    <li>
                      <div class="avalibity-date">
                        <span><i class="feather-calendar"></i></span>
                        <div class="avalibity-datecontent">
                          <div class="d-flex justify-content-start align-items-start gap-2">
                            <h6>Ngày bắt đầu: </h6>
                            <h5>{{ formatNewDate(item.date_start, "dd/MM/yyyy") }}</h5>
                          </div>
                          <div class="d-flex justify-content-start align-items-start gap-2">
                            <h6>Ngày kết thúc: </h6>
                            <h5>{{ formatNewDate(item.date_end, "dd/MM/yyyy") }}</h5>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="list-reviews mb-0">
                        <div class="d-flex align-items-center">
                          <span>{{ item.Reviews }}</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Featured Item -->

        <div class="col-12 text-center mt-3">
          <a class="btn btn-load" href="javascript:;">
            Xem thêm giải đấu
            <img alt="Icon" class="ms-2" src="@/assets/img/icons/u_plus-square.svg"/>
          </a>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Content -->

  <layout-footer></layout-footer>
</template>

<script setup>
import {GET_TOURNAMENT} from "@/graphql/operations/tournament.ts";
import {useQuery} from "@vue/apollo-composable";
import {ref, watch} from "vue";
import {formatNewDate} from "@/utils/datetime";

const url = process.env.VUE_APP_SERVER_URL;

const {result: tournaments} = useQuery(GET_TOURNAMENT);
const data = ref([]);
import {useAuthStore} from "@/stores/auth";

const authStore = useAuthStore();

watch(
    tournaments,
    () => {
      data.value = tournaments.value?.tournaments?.map(item => ({
        ...item,
        isSelected: false,
      }));
    },
    {immediate: true, deep: true}
);

const title = ref("Giải đấu");
const text = ref("Trang chủ");
const text1 = ref("Giải đấu");

function toggleSelected(item) {
  item.isSelected = !item.isSelected;
}
</script>

<style scoped>
.listing-details-group {
  min-height: 60px;
  overflow: hidden;
}

.listing-item {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.listing-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
